import { FormAnalyticsProvider } from 'components/form-analytic-provider';
import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { importExcelToBatchWorkspaceThunk } from 'state/batchForm/importExcel/importExcel.thunks';
import type { ThunkDispatch } from 'state/state.common';
import { workspaceTabCreatedThunk } from 'state/workspaces/workspace.thunks';
import { getToastUtils } from 'utils/toast';

import { ConnectedBatchTabContent } from './TabContent/BatchTabContent';

export const BatchWorkspace: FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();

  const onAddNewTab = useCallback(() => {
    dispatch(workspaceTabCreatedThunk('newBatch', 'quote'));
  }, [dispatch]);

  const handleFileInputChange = useCallback(
    async (event: Event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (!file) {
        return;
      }

      try {
        const buffer = await file.arrayBuffer();
        dispatch(importExcelToBatchWorkspaceThunk(buffer));
      } catch {
        const toast = getToastUtils(dispatch);
        toast.error({ id: 'quote.import.batchWorkspace.failed' }, { id: 'quote.import.button' });
      }
    },
    [dispatch],
  );

  const onImportExcel = useCallback(() => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xlsx';
    fileInput.addEventListener('change', handleFileInputChange);
    fileInput.click();
  }, [handleFileInputChange]);

  return (
    <FormAnalyticsProvider name="batch form">
      <QuoteWorkspaceProvider value="newBatch">
        <ConnectedTabsWorkspace
          workspace="newBatch"
          onAddNewTab={onAddNewTab}
          onImportExcel={onImportExcel}
          paddingClassName="ps-1"
          e2e="quote-form-container"
        >
          {tab =>
            tab !== null ? (
              <div className="flex-grow-1 w-100 min-h-0 bg-lvl3">
                <ConnectedBatchTabContent tabId={tab.id} />
              </div>
            ) : null
          }
        </ConnectedTabsWorkspace>
      </QuoteWorkspaceProvider>
    </FormAnalyticsProvider>
  );
};

BatchWorkspace.displayName = 'BatchWorkspacee';
